import {
  TTrackTypes,
  TGameCustomization,
  ICartItemHeadless,
  TTermsAndConditionsContent,
  TMetaObjectBannerSection,
  TMetaObjectMainTrackConfig,
  TMetaObjectMiniTrackConfig,
  TMetaObjectVRConfig,
  TUpsellModalConfig,
  TMetaObjectSeatsAndRacesConfig,
} from "../types";
import mainTrackImageBanner from "../assets/images/main_track_.jpg";
import miniTrackImageBanner from "../assets/images/miniTrack_.jpeg";
import virtualRealityImageBanner from "../assets/images/virtualReality.jpg";
import { ITrackContextValue } from "./useContextInterface";

const currentHref = window.location.pathname;

type DefaultTrackSelection = {
  title: TTrackTypes;
  trackBanner: string;
};

const defaultTrack = (): DefaultTrackSelection => {
  if (currentHref.endsWith("/main-go-karting-track") || /\d{6}mt$/.test(currentHref)) {
    return {
      title: "RACING_GAMES_TRACK",
      trackBanner: mainTrackImageBanner,
    };
  } else if (currentHref.endsWith("/kids-go-karting-track") || /\d{7}mi$/.test(currentHref)) {
    return {
      title: "RACING_GAMES_TRACK",
      trackBanner: miniTrackImageBanner,
    };
  } else if (currentHref.endsWith("/hyper-reality-vr-arcade") || /\d{6}vr$/.test(currentHref)) {
    return {
      title: "VIRTUAL_REALITY",
      trackBanner: virtualRealityImageBanner,
    };
  } else if (currentHref.endsWith("/junior-track") || /\d{6}jt$/.test(currentHref)) {
    return {
      title: "RACING_GAMES_TRACK",
      trackBanner: mainTrackImageBanner,
    };
  } else {
    return {
      title: "RACING_GAMES_TRACK",
      trackBanner: mainTrackImageBanner,
    };
  }
};

// All the INITIAL_STATE property/values depends on useContextInterfaceValue.ts
// the useTrackContext.tsx will create context and context provider also use useContextInterfaceValue.ts

export const INITIAL_STATE: ITrackContextValue = {
  isCustomerLogged: false,
  isFirstVisit: true,
  productRenderedLocation: "internal",
  appHostedAt: null,
  headlessCartInfo: {
    id: "",
    checkoutUrl: "",
  },
  headlessCartRemoveItem: {
    displayCartComfirmationPopup: false,
    shouldItemRemove: false,
    ItemId: "",
  },
  headlessCartTotalAmount: "",
  headlessCart: [] as ICartItemHeadless[],
  isNewsletterSubscripted: false,
  shopifyCartVariants: [],
  isShopifyCartVariantsLoaded: false,
  isProductLoading: false,
  notification: {
    title: "",
    content: "",
    isVisible: false,
    variant: null,
  },
  isHeadlessMiniCartIsShowing: false,
  trackSelectionOption: defaultTrack(),
  isCartEmpty: true,

  mainTrackSelection: {
    ageGroup: null,
    disableDatesForUnderSixteenAgeGroup: [] as Date[],
    raceType: null,
    variantsAndDate: {
      selectedSessionTime: null,
      selectedDate: new Date(),
      selectedVariants: [],
      selectedVariantsForUpsell: [],
    },
    racesSeats: {
      numberOfSeats: 2,
      numberOfRaces: 3,
    },
    isTermsAndConditionExcepted: false,
    displayPopup: false,
    showInformationPopup: true,
  },
  juniorTrackSelection: {
    variantsAndDate: {
      selectedSessionTime: null,
      selectedDate: new Date(),
      selectedVariants: [],
      selectedVariantsForUpsell: [],
    },
    racesSeats: {
      numberOfSeats: 2,
      numberOfRaces: 3,
    },
    isTermsAndConditionExcepted: false,
  },
  battleKartSelection: {
    variantsAndDate: {
      selectedSessionTime: null,
      selectedDate: new Date(),
      selectedVariants: [],
      selectedVariantsForUpsell: [],
    },
    racesSeats: {
      numberOfSeats: 2,
      numberOfRaces: 3,
    },
    isTermsAndConditionExcepted: false,
  },
  miniTrackSection: {
    variantsAndDate: {
      selectedSessionTime: null,
      selectedDate: new Date(),
      selectedVariants: [],
      selectedVariantsForUpsell: [],
    },
    racesSeats: {
      numberOfSeats: 2,
      numberOfRaces: 2,
    },
    isTermsAndConditionExcepted: false,
  },
  vrSelection: {
    variantsAndDate: {
      selectedSessionTime: null,
      selectedDate: new Date(),
      selectedVariants: [],
      selectedVariantsForUpsell: [],
    },
    joinedVariants: [],
    selectedGame: "CyberClash",
    gameCustomization: [] as TGameCustomization[],
    playersandsessions: {
      numberOfPlayers: 2,
      numberOfSessions: 2,
    },
    isTermsAndConditionExcepted: false,
  },
  arcadeSelection: {
    arcadeGameChoose: {
      selectedArcadeGame: "10",
      selectedVariantId: "",
      isProductOutOfStock: false,
      selectedQuantity: 1,
    },
  },
  dispatch: () => {},
  termsAndConditionsContent: [] as TTermsAndConditionsContent[],
  mainTrackUpsellImageIds: [] as string[],
  miniTrackUpsellImageIds: [] as string[],
  virtualRealityUpsellImageIds: [] as string[],
  mainTrackUpsellImageUrls: [],
  miniTrackUpsellImageUrls: [],
  virtualRealityUpsellImageUrls: [],
  progressiveBarBreadcrumbsRoutes: [] as string[],
  windowWidth: 0,
  metaObjectTrackSelectionConfig: {} as TMetaObjectBannerSection,
  metaObjectMainTrackSectionConfig: {} as TMetaObjectMainTrackConfig,
  metaObjectMiniTrackSectionConfig: {} as TMetaObjectMiniTrackConfig,
  metaObjectVRSectionConfig: {} as TMetaObjectVRConfig,
  metaObjectJuniorTrackSectionConfig: {} as TMetaObjectSeatsAndRacesConfig,
  metaObjectBattleKartTrackSectionConfig: {
    calenderAndTimeslotSection: {
      gamesConfig: {}
    }
  } as TMetaObjectSeatsAndRacesConfig,
  upsellModalConfig: {} as TUpsellModalConfig,
};
